module.exports = __webpack_public_path__ + "static/label-numbers-about01.b825d117.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/mb/about/label-numbers-about01.png
// module id = 540
// module chunks = 263791100135453